import React from 'react'
import { Alert, Button, Checkbox, Modal } from 'antd'

const CopyDeviceDataModal = ({
                                 open,
                                 copySections,
                                 selectedSections,
                                 onCancel,
                                 onConfirm,
                                 onSelectAll,
                                 onClear,
                                 onSectionChange,
                                 t,
                             }) => (
    <Modal
        title={t('pages.devices.detailColumns.copyDevice.title')}
        open={open}
        className='device-copy-modal-dialog'
        okText={t('pages.devices.detailColumns.copyDevice.confirm')}
        cancelText={t('pages.devices.detailColumns.copyDevice.cancel')}
        okButtonProps={{ disabled: selectedSections.length === 0 }}
        width={620}
        onOk={onConfirm}
        onCancel={onCancel}
    >
        <div className='device-copy-modal'>
            <p className='device-copy-modal__description'>
                {t('pages.devices.detailColumns.copyDevice.description')}
            </p>
            <Alert
                type='info'
                showIcon
                className='device-copy-modal__notice'
                message={t('pages.devices.detailColumns.copyDevice.serialNotice')}
            />
            <div className='device-copy-modal__toolbar'>
				<span>
					{t('pages.devices.detailColumns.copyDevice.selectedCount', {
                        count: selectedSections.length,
                        total: copySections.length,
                    })}
				</span>
                <div className='device-copy-modal__toolbar-actions'>
                    <Button type='link' size='small' onClick={onSelectAll}>
                        {t('pages.devices.detailColumns.copyDevice.selectAll')}
                    </Button>
                    <Button type='link' size='small' onClick={onClear}>
                        {t('pages.devices.detailColumns.copyDevice.clear')}
                    </Button>
                </div>
            </div>
            <div className='device-copy-modal__sections'>
                {copySections.map(section => {
                    const checked = selectedSections.includes(section.value)

                    return (
                        <Checkbox
                            key={section.value}
                            checked={checked}
                            className={`device-copy-modal__section ${checked ? 'device-copy-modal__section--selected' : ''}`}
                            onChange={event =>
                                onSectionChange(section.value, event.target.checked)
                            }
                        >
							<span className='device-copy-modal__section-icon'>
								{section.icon}
							</span>
                            <span className='device-copy-modal__section-copy'>
								<strong>{section.label}</strong>
								<span>{section.description}</span>
							</span>
                        </Checkbox>
                    )
                })}
            </div>
            {selectedSections.length === 0 && (
                <p className='device-copy-modal__warning'>
                    {t('pages.devices.detailColumns.copyDevice.required')}
                </p>
            )}
        </div>
    </Modal>
)

export default CopyDeviceDataModal
